import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { Link } from 'react-router'

import { RedoOutlined, UndoOutlined, YoutubeOutlined } from '@ant-design/icons'
import { Descriptions, Flex, Typography } from 'antd'

import { useCountries } from '../../components/country'
import { Country } from '../../components/icon/Country'
import { Title } from '../../components/text/Title'

const Information: FC<
  Partial<
    Omit<TrackCardFragment, 'stats'> & {
      video?: string | null
      stats: MotoGP.RiderStats
    }
  >
> = (datum) => {
  const { formatMessage } = useIntl()
  const { getNameByIso } = useCountries()
  return (
    <Flex vertical gap={40}>
      <Descriptions
        title={
          <Title style={{ marginBottom: 0 }} level={4}>
            {formatMessage({ id: 'track.info' })}
          </Title>
        }
        layout={'horizontal'}
        column={1}
        size={'small'}
        items={[
          {
            label: formatMessage({ id: 'track.country' }),
            children: datum.country ? (
              <Flex gap={8} align={'center'}>
                <Country height={16} country={datum.country} />
                <Typography.Text ellipsis>{getNameByIso(datum.country)}</Typography.Text>
              </Flex>
            ) : null,
          },
          {
            label: formatMessage({ id: 'track.video' }),
            children: datum?.video ? (
              <Flex gap={8}>
                <YoutubeOutlined style={{ fontSize: 24 }} />
                <Link to={datum.video} target={'_blank'} rel={'noreferrer nofollow'}>
                  {formatMessage({ id: 'track.video.on-board' })}
                </Link>
              </Flex>
            ) : null,
          },
          {
            label: formatMessage({ id: 'track.direction' }),
            children:
              datum.direction === 'CLOCK_WISE' ? (
                <RedoOutlined style={{ fontSize: 24 }} />
              ) : (
                <UndoOutlined style={{ fontSize: 24 }} />
              ),
          },
        ].filter((it) => !!it.children)}
      />
      <Descriptions
        title={
          <Title style={{ marginBottom: 0 }} level={4}>
            {formatMessage({ id: 'track.specs' })}
          </Title>
        }
        layout={'horizontal'}
        column={1}
        size={'small'}
        items={[
          {
            label: formatMessage({ id: 'track.total-length' }),
            children: [datum.totalLength, 'm'].join(''),
          },
          {
            label: formatMessage({ id: 'track.total-width' }),
            children: [datum.totalWidth, 'm'].join(''),
          },
          {
            label: formatMessage({ id: 'track.left-corners' }),
            children: datum.leftCorners,
          },
          {
            label: formatMessage({ id: 'track.right-corners' }),
            children: datum.rightCorners,
          },
          {
            label: formatMessage({ id: 'track.longest-straight-length' }),
            children: [datum?.longestStraightLength, 'm'].join(''),
          },
        ]}
      />
    </Flex>
  )
}

export { Information }
